    <template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="back">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-6 col-sm-6 col-6 text-center remove-padding">
                <h6 class="font-16 font-weight-bold remove-margin">Pengaturan Nota</h6>
                </div>
                <div class="col-md-3 col-sm-3 col-3 remove-padding"></div>
            </div>
        </div>
        <main class="">
            <div class=" flex-100">
                <div class="flex-1 pad-top-50">
                    <div class="add-padding-default text-outlets mar-top-20 ">
						<!--<h3 class="font-16 font-weight-bold remove-margin"><b>Print Nota Setelah Diambil</b></h3>-->
						<!--<h6 class="remove-margin">Anda dapat menambahkan pengaturan untuk nota yang akan dicetak untuk tiap transaksi.</h6>-->
	                    <h3 class="font-16 font-weight-bold remove-margin"><b>Pengaturan Umum</b></h3>
                    </div>
                    <div class="custom-control custom-checkbox add-padding-default mar-top-20" @click="chekednotaizinkan">
                        <input type="checkbox" :disabled="!validateAccess('noteSetting.update')" class="custom-control-input" id="customCheckNota" v-model="datanota.outlet.print_ambil">
                        <label class="custom-control-label f-c-blue" for="customCheckNota">Izinkan print nota setelah laundry diambil</label>
                    </div>
	                <div class="custom-control custom-checkbox add-padding-default mar-top-20" @click="printlogo">
		                <input type="checkbox" :disabled="!validateAccess('noteSetting.update')" class="custom-control-input" id="customCheckLogo" v-model="datanota.outlet.display_logo">
		                <label class="custom-control-label f-c-blue" for="customCheckLogo">Tampilkan logo pada nota</label>
	                </div>
                    <div class="pembatas-new"></div>
                    <div class="add-padding-default text-outlets mar-top-20 mar-bottom-30">
                        <h3 class="font-16 font-weight-bold remove-margin"><b>Pengaturan Text Informasi</b></h3>
                        <h6 class="remove-margin font-14 f-c-midgrey">Anda bisa menambahkan text informasi pada nota yang akan dicetak. Text akan ditampilkan dibagian bawah nota.</h6>
                    </div>
                    <div class="">
                        <div class="card-nota" @click="Nexttransaksi">
                            <div class="row mar-top-15 mar-bottom-20 remove-mar-lr add-padding-default">
                                <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                    <div class="font-weight-bold">Nota Transaksi</div>
                                   <div class="coba" v-if="datanota.outlet.nota_transaksi==='' || containsTextDefault(datanota.outlet.nota_transaksi, '#notatransaksidefault#')">
                                       <div class="font-12">Text Belum diatur</div>
                                   </div>
                                    <div class="coba-else" v-else>
                                        <div class="font-12">Text Sudah diatur</div>
                                    </div>
                                </div>
                                <div class="col-md-2 col-sm-2 col-2 text-right remove-padding">
                                    <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="card-nota" @click="Nextdeposit">
                            <div class="row mar-top-15 mar-bottom-20 remove-mar-lr add-padding-default">
                                <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                    <div class="font-weight-bold">Nota Pembelian Deposit</div>
                                    <div class="coba" v-if="datanota.outlet.nota_beli_deposit==='' || containsTextDefault(datanota.outlet.nota_beli_deposit, '#notadepositdefault#')">
                                        <div class="font-12">Text Belum Diatur</div>
                                    </div>
                                    <div class="coba-else" v-else>
                                        <div class="font-12">Text Sudah Diatur</div>
                                    </div>
                                </div>
                                <div class="col-md-2 col-sm-2 col-2 text-right remove-padding">
                                    <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="card-nota" @click="Nextepayment">
                            <div class="row mar-top-15 mar-bottom-20 remove-mar-lr add-padding-default">
                                <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                    <div class="font-weight-bold">Nota Pembelian E-Payment</div>
                                    <div class="coba" v-if="datanota.outlet.nota_beli_emoney==='' || containsTextDefault(datanota.outlet.nota_beli_emoney, '#notaepaymentdefault#')">
                                        <div class="font-12">Text Belum Diatur</div>
                                    </div>
                                    <div class="coba-else" v-else>
                                        <div class="font-12">Text Sudah Diatur</div>
                                    </div>
                                </div>
                                <div class="col-md-2 col-sm-2 col-2 text-right remove-padding">
                                    <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="lebih-sedikit text-alignC" id="text"  @click="showmore" >
                            <h6 class="remove-padding-margin color-206CF" id="textmore">Lihat Lebih Banyak
                            <img class="rotate" src="../../assets/icons/chevron-rotate-down.svg" alt="" id="nomore">
                        </h6>
                        </div>
                        <div class="" id="card" style="display: none">
                            <div class="card-nota" @click="Nextjemputkonsumen">
                                <div class="row mar-top-15 mar-bottom-20 remove-mar-lr add-padding-default">
                                    <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                        <div class="font-weight-bold">Nota Penjemputan dari Konsumen </div>
                                        <div class="coba" v-if="datanota.outlet.nota_surat_jemput==='' || containsTextDefault(datanota.outlet.nota_surat_jemput, '#notajemputdefault#')">
                                            <div class="font-12">Text Belum Diatur</div>
                                        </div>
                                        <div class="coba-else" v-else>
                                            <div class="font-12">Text Sudah Diatur</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-sm-2 col-2 text-right remove-padding">
                                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="card-nota" @click="Nextpaylink">
                                <div class="row mar-top-15 mar-bottom-20 remove-mar-lr add-padding-default">
                                    <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                        <div class="font-weight-bold">Nota Pembelian Paylink</div>
                                        <div class="coba">
                                            <div class="font-12">Text Belum di atur</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-sm-2 col-2 text-right remove-padding">
                                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="card-nota" @click="Nextmember">
                                <div class="row mar-top-15 mar-bottom-20 remove-mar-lr add-padding-default">
                                    <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                        <div class="font-weight-bold">Nota Pendaftaran Member</div>
                                        <div class="coba" v-if="datanota.outlet.nota_daftar_member==='' || containsTextDefault(datanota.outlet.nota_daftar_member, '#notamemberdefault#')">
                                            <div class="font-12">Text Belum Diatur</div>
                                        </div>
                                        <div class="coba-else" v-else>
                                            <div class="font-12">Text Sudah Diatur</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-sm-2 col-2 text-right remove-padding">
                                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="card-nota" @click="Nextsuratpengantar">
                                <div class="row mar-top-15 mar-bottom-20 remove-mar-lr add-padding-default">
                                    <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                        <div class="font-weight-bold">Surat Pengantaran</div>
                                        <div class="coba" v-if="datanota.outlet.nota_surat_antar==='' || containsTextDefault(datanota.outlet.nota_surat_antar, '#notaantarkonsumendefault#')">
                                            <div class="font-12">Text Belum Diatur</div>
                                        </div>
                                        <div class="coba-else" v-else>
                                            <div class="font-12">Text Sudah Diatur</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-sm-2 col-2 text-right remove-padding">
                                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="card-nota" @click="Nextsuratpengantarworkshop">
                                <div class="row mar-top-15 mar-bottom-20 remove-mar-lr add-padding-default">
                                    <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                        <div class="font-weight-bold">Surat Pengantaran ke Workshop</div>
                                        <div class="coba" v-if="datanota.outlet.nota_surat_antar_workshop==='' || containsTextDefault(datanota.outlet.nota_surat_antar_workshop, '#notaantarworkshopdefault#')">
                                            <div class="font-12">Text Belum Diatur</div>
                                        </div>
                                        <div class="coba-else" v-else>
                                            <div class="font-12">Text Sudah Diatur</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-sm-2 col-2 text-right remove-padding">
                                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="card-nota" @click="Nextsuratpenjemputanworkshop">
                                <div class="row mar-top-15 mar-bottom-20 remove-mar-lr add-padding-default">
                                    <div class="col-md-10 col-sm-10 col-10 remove-padding">
                                        <div class="font-weight-bold">Surat Penjemputan ke Workshop</div>
                                        <div class="coba" v-if="datanota.outlet.nota_surat_jemput_workshop ==='' || containsTextDefault(datanota.outlet.nota_surat_jemput_workshop, '#notajemputworkshopdefault#')">
                                            <div class="font-12">Text Belum Diatur</div>
                                        </div>
                                        <div class="coba-else" v-else>
                                            <div class="font-12">Text Sudah Diatur</div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-sm-2 col-2 text-right remove-padding">
                                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <div class="modal fade" id="modalnota" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Konfirmasi ijin Print Nota</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div>Apakah Anda yakin akan memberikan ijin pada kasir untuk mencetak nota setelah transaksi selesai? </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                id="print-nota"
                                @click="printnotakasir">Ya, Ubah
                        </button>
<!--	                    <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"-->
<!--	                            id="print-logo"-->
<!--	                            @click="printlogo">Ya, Ubah-->
<!--	                    </button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Nota",
        props:['setidoutlet','datanota','setidoutletsetnota','datatextnota'],
        mounted(){
            this.idoutlet = this.$route.params.idoutlet
        },
        data(){
          return{
              outlet:{},
              idoutlet:this.setidoutlet,
              requestHeaders: {
                  headers: {
                      'Authorization': 'Bearer ' + localStorage.getItem('token'),
                  }
              }
          }
        },
        methods:{
            back(){
                this.$emit('isdetailsetnota')
                document.documentElement.scrollTop = 0;
            },
	        containsTextDefault(str, strContain = "#teksdefault#") {
            	if (str) {
		            return str.includes(strContain)
	            }
	        },
            Nexttransaksi(){
                this.$emit('gototextnota', 1);

            },
            Nextdeposit(){
                this.$emit('gototextnota', 2);
            },
            Nextepayment(){
                this.$emit('gototextnota', 3);
            },
            Nextjemputkonsumen(){
                this.$emit('gototextnota', 4);
            },
            Nextpaylink(){
                this.$emit('gototextnota', 5);
            },
            Nextmember(){
                this.$emit('gototextnota', 6);
            },
            Nextsuratpengantar(){
                this.$emit('gototextnota', 7);
            },
            Nextsuratpengantarworkshop(){
                this.$emit('gototextnota', 8);
            },
            Nextsuratpenjemputanworkshop(){
                this.$emit('gototextnota', 9);
            },
            showmore(){
                $('#card').slideToggle(400)
                this.rotate()
            },
            rotate(){
                    $('.rotate').toggleClass("down");
            },

            async printnotakasir(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
	                if (this.datanota.outlet.print_ambil===0) {
		                $('#customCheckNota').prop('checked', false)
		                this.datanota.outlet.print_ambil = 1
	                } else {
		                $('#customCheckNota').prop('checked', true)
		                this.datanota.outlet.print_ambil = 0
	                }
                	
                    const checkkasir = new FormData;
                    checkkasir.append('print_ambil', this.datanota.outlet.print_ambil);
                    checkkasir.append('idoutlet', this.setidoutletsetnota);
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_izin_print_nota_diambil',checkkasir,this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.$emit('getnota')
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }

            },
	
	        async printlogo(e){
                if (!this.validateAccess('noteSetting.update')) return
                e.preventDefault()
		        $('#loadingPage').show();
		        $('#loadingPage').addClass('overlayLoading');
		        try {
			        if (this.datanota.outlet.display_logo===0) {
				        $('#customCheckLogo').prop('checked', false)
				        this.datanota.outlet.display_logo = 1
			        } else {
				        $('#customCheckLogo').prop('checked', true)
				        this.datanota.outlet.display_logo = 0
			        }
			
			        const checklogo = new FormData;
			        checklogo.append('display_logo', this.datanota.outlet.display_logo);
			        checklogo.append('idoutlet', this.setidoutletsetnota);
			        const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_display_logo_nota',checklogo,this.requestHeaders);
			        if (response.data.status === true) {
				        $('#loadingPage').hide();
				        $('#loadingPage').removeClass('overlayLoading');
				        this.$emit('getnota')
			        }
		        }catch (e) {
		        	this.$catch_error_response(e)
			        $('#loadingPage').hide();
			        $('#loadingPage').removeClass('overlayLoading');
		        }
		
	        },

            chekednotaizinkan(e){
                if (!this.validateAccess('noteSetting.update')) return
                e.preventDefault();
                $('#modalnota').modal('show');
                $("#print-nota").show();
	            $("#print-logo").hide();
            },
	        chekedlogo(e) {
            	e.preventDefault()
		        $('#modalnota').modal('show');
		        $("#print-nota").hide();
		        $("#print-logo").show();
	        },



            async getnotatransaksinotattext(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/nota_transaksi_meta?idoutlet=' + this.setidoutletsetnota, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.outlet = response.data.data;
                        this.datatextnota.textpage = response.data.data.nota_transaksi;
                    }else {

                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getnotadeposit(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/nota_beli_deposit?idoutlet=' + this.setidoutletsetnota, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.outlet = response.data.data
                        this.datatextnota.textpage = response.data.data.nota_beli_deposit
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getnotaepayment(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/nota_beli_emoney?idoutlet=' + this.setidoutletsetnota, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.outlet = response.data.data;
                        this.datatextnota.textpage = response.data.data.nota_beli_emoney
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getnotapenjemputankonsumen(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/nota_surat_jemput?idoutlet=' + this.setidoutletsetnota, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.outlet = response.data.data
                        this.datatextnota.textpage = response.data.data.nota_surat_jemput
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getnotapaylink(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
	            try {
		            const response = await this.$axios.get(this.$baseurl + '/masterData/meta/nota_surat_topup_paylink?idoutlet=' + this.setidoutletsetnota, this.requestHeaders);
		            if (response.data.status === true) {
			            $('#loadingPage').hide();
			            $('#loadingPage').removeClass('overlayLoading');
			            this.outlet = response.data.data
			            this.datatextnota.textpage = response.data.data.nota_topup_paylink
		            }
		
	            }catch (e) {
		            this.$catch_error_response(e)
		            $('#loadingPage').hide();
		            $('#loadingPage').removeClass('overlayLoading');
	            }
            },
            async getnotamember(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/nota_daftar_member?idoutlet=' + this.setidoutletsetnota, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.outlet = response.data.data
                        this.datatextnota.textpage = response.data.data.nota_daftar_member
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getsuratpengantaran(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/nota_surat_antar?idoutlet=' + this.setidoutletsetnota, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.outlet = response.data.data
                        this.datatextnota.textpage = response.data.data.nota_surat_antar
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getsuratpengantarwk(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/nota_surat_antar_workshop?idoutlet=' + this.setidoutletsetnota, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.outlet = response.data.data
                        this.datatextnota.textpage = response.data.data.nota_surat_antar_workshop
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getsuratpengambilanwk(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/nota_surat_jemput_workshop?idoutlet=' + this.setidoutletsetnota, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.outlet = response.data.data;
                        this.datatextnota.textpage = response.data.data.nota_surat_jemput_workshop;
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
        }
    }
</script>

<style scoped>
    .pembatas-new{
        display: block;
        width: 100%;
        height: 8px;
        background: #F2F5F7;
        margin-top: 20px;
    }

    .card-nota{
        border-top: 1px solid #EDEDED;

    }

    .lebih-sedikit{
        border-top: 1px solid #EDEDED;
        padding: 24px 0px;
    }

    .coba{
        background: #F3F3F3;;
        border-radius: 55px;
        padding: 2px 10px;
        font-weight: 600;
        color:  #A7A7A7;
        display: inline-block;
        line-height: 21px;
    }
    .coba-else{
        background: #E2F0FF;
        border-radius: 55px;
        padding: 2px 10px;
        font-weight: 600;
        color: #5F95FF;
        display: inline-block;
        line-height: 21px;
    }
</style>